<div class="d-flex card">
	<div class="d-flex">
		<div class="display-6 ms-1 mt-2 mb-1" (click)="test()">URL Alias</div>
		<div class="ms-auto">
			<app-record-control-footer
				[hideAdd]="false"
				[hideCancel]="true"
				[hideDelete]="true"
				[hideSave]="true"
				(onAddChange)="newAlias()"
			></app-record-control-footer>
		</div>
	</div>
	<p-divider></p-divider>
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="venueAliases"
		[loading]="!venueAliases"
		[globalFilterFields]="app.keys(venueAliases)"
		[scrollable]="true"
		[rows]="100"
		scrollHeight="700px"
		[virtualScroll]="true"
		[virtualRowHeight]="40"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th>Alias</th>
				<th>Custom Menu</th>
				<th>Last Visited</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr (click)="venueAliasSelected = rec">
				<td>
					{{ rec.alias }}
				</td>
				<td>
					{{ rec.customMenu?.name }}
				</td>
				<td>
					<span *ngIf="rec.lastAccessed">
						{{ moment(rec.lastAccessed).format("l LT") }}
					</span>
					<span *ngIf="!rec.lastAccessed"> ---- </span>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<p-dialog [(visible)]="venueAliasSelected" *ngIf="venueAliasSelected" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<p-header>
		<div class="h3">Create URL Alias</div>
	</p-header>
	<div class="d-flex flex-column">
		<span class="p-float-label flex-fill mt-4 mx-2">
			<input pInputText type="text" id="alias" name="allias" [(ngModel)]="venueAliasSelected.alias" class="w-100" />
			<label for="alias">URL Alias</label>
		</span>
		<span class="p-float-label mt-4 mx-2">
			<p-dropdown
				[options]="venueService.subscriptionOOmenu.value"
				[autoDisplayFirst]="false"
				id="menu"
				optionLabel="name"
				optionValue="key"
				name="name"
				[(ngModel)]="venueAliasSelected.menuKey"
				[style]="{ width: '100%' }"
				appendTo="body"
			></p-dropdown>
			<label for="menu">Custom Menu</label>
		</span>
	</div>
	<ng-template pTemplate="footer">
		<app-record-control-footer
			[hideCancel]=""
			[hideDelete]=""
			[hideSave]=""
			(onCancelChange)="venueAliasSelected = undefined"
			(onDeleteChange)="delete(venueAliasSelected)"
			(onSaveChange)="save()"
			[cancelDisabled]=""
			[deleteDisabled]=""
			[saveDisabled]="!venueAliasSelected.alias"
			[deletePromptOverride]="true"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
